<template>
  <el-table-column
    prop="orders"
    label="Rendelések"
    min-width="200"
  >
    <template slot-scope="scope">
      <receipt-link
          v-for="order in (scope.row.related_data && scope.row.related_data.customerOrders || [])"
          :id="order.id"
          :label="order.receipt_number"
          type="customerOrder"
          style="display: inline-block; margin-right: 5px;"
      />
      <receipt-link
          v-for="order in (scope.row.related_data && scope.row.related_data.representativeOrders || [])"
          :id="order.id + '-representative'"
          :label="order.receipt_number"
          type="representativeOrder"
          style="display: inline-block; margin-right: 5px;"
      />
    </template>
  </el-table-column>
</template>

<script>
  import ReceiptLink from '../../../utils/ReceiptLink';

  export default {
    components: {
      ReceiptLink,
    },
    propName: 'receipt_number',
  };
</script>
